import { FilterConfig } from 'App/babel/filterConfigs/FilterConfig';

const quotaFilterConfigs = (): { [key: string]: FilterConfig } => ({
	User: {
		field: 'user.id',
		title: 'default.users',
		type: 'list'
	},
	Currency: {
		field: 'currency',
		title: 'default.currency',
		type: 'list'
	}
});

export default quotaFilterConfigs;
